import React from "react";
import classNames from "classnames";
import { get } from "lodash";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import {
  ACTIONS_REQUESTED,
  getConditionAbbrev
} from "MODULES/RepairOrders/constants";
import { Icon, LocationFlag } from "MODULES/shared/components";
import { shortDateYY } from "LIB/formatters/date";
import StatusNote from "MODULES/RepairOrders/components/Detail/LineItems/StatusNote";
import MultiLocationFeature from "MODULES/shared/components/MultiLocationFeature/MultiLocationFeature";
import { ExchangeIcon } from "MODULES/RepairOrders/helpers";
import StatusBadges from "./StatusBadges";
import hiddenInputs from "../../../../shared/components/Forms/hiddenInputs";
import PartNumber from "../../../../shared/components/PartNumber/PartNumber";

const hiddenEnhancer = hiddenInputs({
  HiddenTh: props => <th {...props}>{props.children}</th>,
  HiddenTd: props => <td {...props}>{props.children}</td>
});

export class Table extends React.Component {
  clickable = classNames({ clickable: !this.props.disabled });

  renderRow = (lineItem, i, HiddenTd, startColumns = {}, endColumns = {}) => (
    <tr
      key={i}
      className={this.clickable}
      onClick={() => {
        if (!this.props.disabled) {
          this.props.onItemClick(lineItem);
        }
      }}
    >
      <td>{i + 1}</td>
      {Object.keys(startColumns).map(k => {
        const Component = startColumns[k];
        return (
          <td>
            <Component lineItem={lineItem} />
          </td>
        );
      })}
      <td>
        <PartNumber
          part={{
            id: lineItem.part_id,
            part_number: lineItem.part.part_number,
            uuid: lineItem.part.uuid
          }}
        />
      </td>
      <td>
        {lineItem.inventory ? (
          <Link to={`/inventories/${lineItem.inventory.uuid}`}>
            {lineItem.original_serial_number || lineItem.serial_number}
          </Link>
        ) : (
          lineItem.original_serial_number || lineItem.serial_number
        )}
      </td>
      <HiddenTd>
        <PartNumber part={lineItem.mod_to} />
      </HiddenTd>
      <td>{ACTIONS_REQUESTED[lineItem.action_requested].label}</td>
      <td>
        <StatusNote lineItem={lineItem} />
      </td>
      <HiddenTd className="text-center">
        <StatusBadges lineItem={lineItem} />
      </HiddenTd>
      <MultiLocationFeature>
        <HiddenTd className="text-center">
          <LocationFlag
            location={lineItem.return_to_location_id}
            unknownFlag={false}
          />
        </HiddenTd>
      </MultiLocationFeature>
      <HiddenTd className="text-success text-center">
        {lineItem.exchange && <ExchangeIcon lineItem={lineItem} />}
      </HiddenTd>
      <td>{lineItem.work_order_number}</td>
      <td>{getConditionAbbrev(lineItem.condition_sent)}</td>
      <td>{getConditionAbbrev(get(lineItem, "inventory.condition"))}</td>
      <td className="text-center">{shortDateYY(lineItem.eval_due_date)}</td>
      <td className="text-center">{shortDateYY(lineItem.expected_date)}</td>
      <td className="text-right">{lineItem.quantity}</td>
      <td className="text-right">
        {lineItem.received && (
          <span className="text-muted spacing-right">
            <Icon name="cloud-download" />{" "}
          </span>
        )}
        {lineItem.quantity_received}
      </td>
      {Object.keys(endColumns).map(k => {
        const Component = endColumns[k];
        return (
          <td className="text-center">
            <Component lineItem={lineItem} />
          </td>
        );
      })}
    </tr>
  );

  render() {
    const { results, startColumns = {}, endColumns = {} } = this.props;
    const { HiddenTd, HiddenTh } = hiddenEnhancer(
      results.some(r => r.action_requested === "shop_assist")
    );
    return (
      <RepairTable
        HiddenTh={HiddenTh}
        startColumns={startColumns}
        endColumns={endColumns}
      >
        <tbody>
          {results.map((r, i) =>
            this.renderRow(r, i, HiddenTd, startColumns, endColumns)
          )}
        </tbody>
      </RepairTable>
    );
  }
}

export function RepairTable({
  children,
  HiddenTh,
  startColumns = {},
  endColumns = {}
}) {
  return (
    <table className="table table-striped table-hover table-numbered">
      <thead>
        <tr>
          <th />
          {Object.keys(startColumns).map(k => <th>{k}</th>)}
          <th>Part #</th>
          <th>Serial #</th>
          <HiddenTh>Mod To</HiddenTh>
          <th>Action Req.</th>
          <th />
          <HiddenTh className="text-center">Status</HiddenTh>
          <MultiLocationFeature>
            <HiddenTh className="text-center">Return Store</HiddenTh>
          </MultiLocationFeature>
          <HiddenTh className="text-center">Exch</HiddenTh>
          <th>WO #</th>
          <th>CD Sent</th>
          <th>Inv CD</th>
          <th>Eval Due</th>
          <th className="text-center">Expected</th>
          <th className="text-right">QTY</th>
          <th className="text-right">Rec.</th>
          {Object.keys(endColumns).map(k => (
            <th className="text-center">{k}</th>
          ))}
        </tr>
      </thead>
      {children}
    </table>
  );
}

RepairTable.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node)
  ]),
  HiddenTh: PropTypes.node,
  endColumns: PropTypes.shape({}),
  startColumns: PropTypes.shape({})
};

Table.propTypes = {
  disabled: PropTypes.bool,
  endColumns: PropTypes.shape({}),
  onItemClick: PropTypes.func,
  results: PropTypes.arrayOf(PropTypes.shape({})),
  startColumns: PropTypes.shape({})
};



// WEBPACK FOOTER //
// ./app/modules/RepairOrders/components/Detail/LineItems/Table.jsx